import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { FilterableItem } from '../interfaces/types';

interface FilterableItemComponentProps {
    item: FilterableItem;
}

export const FilterableItemComponent: React.FC<FilterableItemComponentProps> = ({ item }) => {
    const ItemContent = () => {
        const preheading = !!item.subtitle ? <p className="preheading"><span className="h6-style">{item.subtitle}</span></p> : null;
        const heading = <h3 className="h4-style contenthighlight-title">{item.title}</h3>;
        return `${renderToStaticMarkup(preheading)}${renderToStaticMarkup(heading)}${item.itemDescription}`;
    }

    const CardContent = () => (
        <div className="contenthighlight-item stack-sm">
            {item.imageUrl !== "" && (
                <div className="media-item">
                    {item.primaryButtonUrl !== null && (
                        <div className="media-item-container">
                            <img
                                className="filter-block-image"
                                src={item.imageUrl}
                                alt={item.imageAltText || item.title}
                                loading="lazy"
                            />
                        </div>
                    )}
                </div>
            )}
            <div className="contenthighlight-item-inner">
                <div
                    className="rich-text"
                    dangerouslySetInnerHTML={{ __html: ItemContent() }}
                />
            </div>
        </div>
    );

    return (
        <>
            {
                !!item.primaryButtonUrl ?
                    <a href={item.primaryButtonUrl} target={item.primaryButtonTarget} className="contenthighlight-linked">{CardContent()}</a>
                    :
                    CardContent()
            }
        </>
    );
};
